import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import DefaultModal from "../../components/modals/DefaultModal";
import { Close, Details } from "@material-ui/icons";
import DefaultToast from "../../components/toasts/DefaultToast";
import { Rating } from "@mui/material";

const CustomerSupportDetails = () => {
  const params = useParams();

  const doubt_id = params.id;

  const { user } = useContext(AuthContext);

  const [show, setShow] = useState(false);
  const [toastData, setToastData] = useState("");
  const [feedback, setfeedback] = useState([]);
  const FetchDetails = async () => {
    const formData = new FormData();

    //formData.append('whyus',document.getElementById('whyus').value)
    formData.append("session", user.SessionId);

    formData.append("id", doubt_id);

    const res = await axios.post(ENDPOINT + "get-customer-support-details.php", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    if (res) {
      if (res.data.status === "success") {
        setdoubts(res.data.data);
        setdetails(res.data.details);
        setfeedback(res.data.feedbacks);

        console.log(res.data)
      } else {
      }
    }
  };

  useEffect(() => {
    FetchDetails();
  }, []);

  const [doubts, setdoubts] = useState(null);
  const [subject, setsubject] = useState(null);
  const [message, setmessage] = useState(null);

  const SaveChanges = async () => {
    const formData = new FormData();

    //formData.append('whyus',document.getElementById('whyus').value)
    formData.append("session", user.SessionId);

    formData.append("subject", subject);
    formData.append("id", doubt_id);
    formData.append("message", message);

    const res = await axios.post(ENDPOINT + "add-customer-support-details.php", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    if (res) {
      if (res.data.status === "success") {
        setShow(true);
        setToastData(res.data.message ? res.data.message : "Successfully added");
        setaddreport(false);
        FetchDetails()
      } else {
      }
    }
  };
  const [details, setdetails] = useState(null);
  const [addreport, setaddreport] = useState(false);
  console.log(doubts&&doubts[0]);
  return (
    <>
      <DefaultToast show={show} toastdata={toastData} handleToastClose={() => setShow(false)} />
      <DefaultModal
        show={addreport}
        HandleClose={() => setaddreport(false)}
        content={
          <>
            <div className="p-2 rounded">
              <div className="modal-header">
                <h4>Add Update</h4>
                <Close onClick={() => setaddreport(false)} />
              </div>
              <hr></hr>
              <input
                value={subject}
                required
                onChange={(e) => setsubject(e.target.value)}
                placeholder="subject"
                className="form-control my-2"
              ></input>
              <textarea
                value={message}
                required
                onChange={(e) => setmessage(e.target.value)}
                placeholder="Add Note"
                className="form-control my-2"
              ></textarea>
              <button
                className="btn btn-success w-100"
                onClick={() => SaveChanges()}
              >
                Save Changes
              </button>
            </div>
          </>
        }
      ></DefaultModal>
      <div className="card no-line">
        {details ?
          <>
            <div className="card-header align-items-center d-flex">
              <div className="d-flex">
                <div className="ms-2 col-12">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="">    {details ? (
                      <>
                        <div className="d-flex col-12">
                          <img src={details.profile_pic} className="avatar-md rounded me-2"></img>
                          <div>
                            <h5>{details.name}</h5>
                            <p className="m-0">Phone : {details.phone}</p>
                            <p className="m-0">Email : {details.email}</p>

                          </div>

                          <div>


                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    </div>
                    <div className="d-flex ms-3  align-items-center">

                      
                      {/* {
                        doubts && doubts.length > 0 ? doubts[0].map((item)=>(
                            <div  className="">
                          <Rating value={item?.rating} readOnly />
                          <p className="m-0 ms-2">{item?.review}</p>

                        </div>
                        )) :<></>
                          
                      } */}

                       {
                        doubts &&
                            <div  className=" ">
                          {doubts[0]?.rating ?
                            <Rating value={doubts[0]?.rating} readOnly />
                            : <></>
                          }
                          <p className="m-0 ms-2">{doubts[0]?.review}</p>

                        </div>
                      
                      }


                      

                    </div>

                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 ms-auto">
                <button
                  onClick={() => setaddreport(true)}
                  className="btn btn-success"
                >
                  Update Doubt Request
                </button>
              </div>
            </div>
            <div className="p-2">
              <h5>Subject: {details.subject}</h5>
              <p className="m-0">Message: {details.message}</p>
            </div>
            <hr className="m-1"></hr>

          </> :
          <>


          </>}
        <div className="">
          <div className="tab-content text-muted">
            <div className="tab-pane active" id="today" role="tabpanel">
              <div className="profile-timeline">
                <div className="accordion accordion-flush d-flex flex-wrap" id="todayExample">
                  {doubts ? (
                    <>
                      {doubts.map((item) => (
                        <>
                          <div className="accordion-item my-2 col-lg-12 col-sm-12 col-12 border-0 ">
                            <div
                              className="accordion-header"
                              id={"heading" + item.id}
                            >
                              <a
                                className="accordion-button p-2 shadow-none"
                                data-bs-toggle="collapse"
                                href={"#collapse" + item.id}
                                aria-expanded="true"
                              >
                                <div className="d-flex justify-content-between w-100">
                                  <div className="d-flex">
                                    <div className="flex-shrink-0">
                                      <img
                                        src={item.reported_by_user.profile_pic}
                                        alt=""
                                        className="avatar-xs rounded-circle material-shadow"
                                      />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                      <h6 className="fs-14 mb-2">
                                        Subject: {item.subject}
                                      </h6>
                                      <small className="text-muted">
                                        {item.reported_by_user.first_name +
                                          " " +
                                          item.reported_by_user.last_name +
                                          " reported at " +
                                          item.create_datetime}
                                      </small>
                                       <div className="  py-0">
                                Note: {item.message}
                              </div>
                                    </div>
                                  </div>
                                {
                                  Array.isArray(item.feedback) && item.feedback.length > 0 ?
                                    <div className="d-flex ms-3 align-items-end col-6">
                                    {item?.feedback.map((item, index) => (
                                      <div key={index} className="">
                                        <Rating value={item.rating} readOnly />
                                        <p className="m-0 ">{item.message}</p>

                                      </div>


                                    ))}
                                  </div>:<>+</>
                                }
                                </div>
                              </a>
                            </div>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingOne"
                              data-bs-parent="#accordionExample"
                            >

                             
                              <hr className="m-0 mb-2"></hr>
                            </div>
                          </div>
                        </>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                {/*end accordion*/}
              </div>
            </div>

          </div>
        </div>
        {/* end card body */}
      </div>
      {/* end card */}


    </>
  );
};

export default CustomerSupportDetails;
